import { useEffect } from 'react'
import { useQuery } from 'react-query'
import { Box, Flex } from '@stoplight/mosaic'
import { Link, useLocation, useHistory } from 'react-router-dom'

import { Article } from '../components/Article'
import { TableOfContents } from '../components/table-of-content/TableOfContents'

import { TableOfContentsItem } from './table-of-content'

type ArticlesProps = {
  items: TableOfContentsItem[]
}

export default function Articles({ items }: ArticlesProps) {
  const history = useHistory()
  const location = useLocation()
  const { pathname } = location

  const { isLoading, data, isFetched, error } = useQuery(
    [pathname],
    async () => {
      const res = await fetch(
        `${process.env.PUBLIC_URL}/articles${pathname}.md`
      )
      if (res.ok) {
        const data = await res.text()

        // If the article files is not found, the index file is loaded by default
        if (
          data.includes('You need to enable JavaScript to run this app.') &&
          pathname.split('/').length > 2
        ) {
          throw new Error('Unable to load article')
        }

        return data
      }

      throw new Error(`Unable to load article, status code: ${res.status}`)
    }
  )

  useEffect(() => {
    if (pathname.split('/').length === 2) {
      history.replace(`${pathname}/overview`)
    }

    // Only want to run this effect on initial render for default section view.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [pathname])

  return (
    <>
      <Box
        // @ts-expect-error
        w={70}
        id="sidebar-nav"
        bg="canvas"
        h="full"
        className="sl-max-h-main sl-border-r sl-absolute sl-overflow-y-scroll sl-overflow-x-auto"
      >
        <TableOfContents
          items={items}
          Link={Link}
          activeId={pathname}
          maxDepthOpenByDefault={2}
        />
      </Box>
      <Box
        bg="canvas"
        className="sl-absolute sl-top-0 sl-bottom-0 sl-right-0 sl-left-70 sl-overflow-y-auto sl-overflow-x-hidden"
      >
        <Flex flexDirection="col" bg="canvas" w="full" alignItems="center">
          <Box
            // @ts-expect-error
            p="5vw"
            // @ts-expect-error
            maxW="main"
            w="full"
            my={0}
            mx="auto"
          >
            <Article {...{ isFetched, isLoading, error, data }} />
          </Box>
        </Flex>
      </Box>
    </>
  )
}
